import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons'

const MenuButton = ({ isNavOpen, toggleNavOpen }) => {
  const menuHamburger = isNavOpen ? (
    <FontAwesomeIcon
      style={{ color: 'black', height: '1rem', width: '1rem' }}
      icon={faTimes}
    />
  ) : (
    <FontAwesomeIcon
      style={{ color: 'black', height: '1rem', width: '1rem' }}
      icon={faBars}
    />
  )

  return (
    <span aria-hidden="true" onClick={toggleNavOpen} type="button" className="menu-button">
      {menuHamburger}
    </span>
  )
}

export default MenuButton
